import { render } from "./QaQcPrintPreview.vue?vue&type=template&id=b845b4d8&scoped=true"
import script from "./QaQcPrintPreview.vue?vue&type=script&lang=js"
export * from "./QaQcPrintPreview.vue?vue&type=script&lang=js"

import "./QaQcPrintPreview.vue?vue&type=style&index=0&id=b845b4d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b845b4d8"]])

export default __exports__